import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-no-record-found",
  templateUrl: "./no-record-found.component.html",
  styleUrls: ["./no-record-found.component.scss"],
  standalone: false,
})
export class NoRecordFoundComponent {
  @Input() variant: "standard" | "compact" | "bordered" | "minimal" | "table" =
    "standard";
  @Input() message: string = "No Record Found";
  @Input() description: string = "";
  @Input() appicon: string = "";
  @Input() appsize: string = "32";
  @Input() appcolor: string = "";
  @Input() buttontext: string = "";
  @Input() buttonicon: string = "";
  @Output() buttonclick = new EventEmitter<string>();


  onClick() {
    this.buttonclick.emit();
  }

}
